import { Grid, styled, Typography } from "@mui/material";
import { api } from "api";
import { AssignmentModelList } from "components/AssignmentModelList";
import { InfoSnackBar } from "components/InfoSnackBar";
import { StyledButton } from "components/StyledButton";
import { Assignment, getStatus } from "helpers/assignment";
import { ACTIVITIES_FETCH_ERR } from "messages";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { routes } from "routes";

const PREFIX = "TrackDashboardPage";

const classes = {
	groups: `${PREFIX}-groups`,
	groupList: `${PREFIX}-grouplist`,
	title: `${PREFIX}-title`,
	button: `${PREFIX}-button`,
	root: `${PREFIX}-root`,
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Root = styled("div")(({ theme }) => ({
	[`&.${classes.root}`]: {
		padding: 20,
	},

	[`& .${classes.button}`]: {
		marginTop: 15,
		marginRight: 5,
		float: "right",
	},

	[`& .${classes.title}`]: {
		marginTop: 5,
		marginBottom: 15,
		float: "left",
	},

	[`& .${classes.groupList}`]: {
		maxHeight: 200,
		padding: 5,
		overflowY: "auto",
		overflowX: "hidden",
		float: "left",
	},
}));

export const Assignments = (): JSX.Element => {
	// new code here
	const componentMounted = useRef(true);
	const history = useHistory();
	const [assignments, setAssignment] = useState<Assignment[]>([]);
	const [err, setErr] = useState(false);

	useEffect(() => {
		api
			.getAssignments()
			.then((res) => {
				if (res.status !== 200) {
					setErr(true);
					return;
				}

				if (componentMounted.current) {
					const now = new Date();
					setAssignment(
						(res.data || []).map((ass) => ({
							...ass,
							status: getStatus(ass, now),
						})),
					);
				}
			})
			.catch(() => {
				setErr(true);
			});
		return () => {
			componentMounted.current = false;
		};
	}, []);

	return (
		<Root className={classes.root}>
			<Grid item xs={12}>
				<Grid container spacing={1}>
					<Grid item xs={12}>
						<Typography className={classes.title} variant="h4">
							Assignments
						</Typography>
						<StyledButton
							variant="contained"
							color="primary"
							className={classes.button}
							onClick={() => {
								history.push(routes._.assignments._.create.path);
							}}
							data-testid="create-button"
						>
							CREATE
						</StyledButton>
					</Grid>

					<Grid item xs={12}>
						{assignments.length === 0 ? (
							<Typography variant="h5" className={classes.title}>
								No ongoing assignments
							</Typography>
						) : (
							<AssignmentModelList assignments={assignments} show_csv={false} />
						)}
					</Grid>
				</Grid>
			</Grid>
			<InfoSnackBar
				isOpen={err}
				onClose={() => setErr(false)}
				message={ACTIVITIES_FETCH_ERR}
				severity="error"
			/>
		</Root>
	);
};
